export const airQualityDescription = (aqi) => {
  if (!aqi) {
    return "error";
  }

  const descriptions = ["Good", "Fair", "Moderate", "Poor", "Very Poor"];
  return descriptions[aqi - 1];
};

export const airQualityColour = (val, minVal, midVal, maxVal) => {
  if (val >= minVal && val < midVal) return "default";
  if (val >= midVal && val < maxVal) return "warning";
  if (val >= maxVal) return "danger";
};
